const Video = () => {
  return (
    <div className="basic-4">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h2>Course Video Presentation</h2>

            <div className="image-container">
              <div className="video-wrapper">
                <a
                  className="popup-youtube"
                  href="https://www.youtube.com/watch?v=fLCjQJCekTs"
                  data-effect="fadeIn"
                >
                  <img
                    className="img-fluid"
                    src="images/video.jpg"
                    alt="alternative"
                  />
                  <span className="video-play-button">
                    <span></span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Video;
